import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { SeedTracker } from 'modules/domain/seedTracker/types'

const seedTrackerDict = (state: AppGlobalState) => state.seedTracker.items
const ids = (state: AppGlobalState) => state.seedTracker.ids
const listFetchProgress = (state: AppGlobalState) => state.seedTracker.listFetchProgress
const seedTrackerList = createSelector(seedTrackerDict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: SeedTracker[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.seedTracker.filter
const sorting = (state: AppGlobalState) => state.seedTracker.sorting
const page = (state: AppGlobalState) => state.seedTracker.page
const total = (state: AppGlobalState) => state.seedTracker.total
const pageSize = (state: AppGlobalState) => state.seedTracker.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.seedTracker.total / state.seedTracker.pageSize)

const seedTracker = (state: AppGlobalState, id: string) => seedTrackerDict(state)[id]
const meta = (state: AppGlobalState, id: string) =>
  state.seedTracker.meta[id] || { fetchProgress: Progress.IDLE, fetchError: null }
const listMeta = (state: AppGlobalState) => state.seedTracker.listMeta

const SeedTrackerSelectors = {
  filter,
  sorting,
  page,
  total,
  seedTrackerDict,
  ids,
  seedTrackerList,
  pageSize,
  pages,
  listFetchProgress,
  seedTracker,
  meta,
  listMeta,
}

export default SeedTrackerSelectors
